import { render, staticRenderFns } from "./UserModifySettingsModal.vue?vue&type=template&id=059dd780&"
import script from "./UserModifySettingsModal.vue?vue&type=script&lang=js&"
export * from "./UserModifySettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports